function initiateOtp(first_name, last_name, tag_string, email) {
return fetch("https://supabase.prolonlife.com/functions/v1/okta-l-nutra-health/initiate-otp", {
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    },
    body: JSON.stringify({ first_name, last_name, tag_string, email, return_to: window.location.href })
}).then(response => response.json())
} 

function verifyOtp(email, otp_code) {
return fetch("https://supabase.prolonlife.com/functions/v1/okta-l-nutra-health/verify-otp", {
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    },
    body: JSON.stringify({ email, otp_code })
}).then(response => response.json())
}

async function verifyAuth(e,em,fn,ln) {
  if (e && e.preventDefault) {
    e.preventDefault()
  } 
 
  let email = em || $("#registration-form #email").val()
  let firstName = fn ||  $("#registration-form #first-name").val()
  let lastName = ln || $("#registration-form #last-name").val()
 
  // only patriotrail.com email allowed or l-nutra.com email allowed
  const emailPattern = /^[a-zA-Z0-9._%+-]+@(patriotrail\.com|l-nutra\.com)$/;
  if (!emailPattern.test(email)) {
    alert("Please enter a valid email address with @patriotrail.com or @l-nutra.com domain.")
    return
  }  
   
  if (firstName && lastName && email) {
    $("#registration-popup").removeClass("hidden")
  } else {
    alert("Please fill in all fields.")
    return
  }
  $(".registration-button").addClass("loading").html("Loading...")
   
  let tag_string = `patriotrail`
  window.c_email = email;
  window.c_first_name = firstName;
  window.c_last_name = lastName;
  try {
    await initiateOtp(firstName, lastName, tag_string, email)
    // show otp modal
    $("#otp-modal").removeClass("hidden")
    $("#registration-popup").addClass("hidden")
  } catch (error) {
    alert("Error initiating OTP. Please try again.")
    console.error("OTP Initiation Error:", error)
  } finally { 
    $(".registration-button").removeClass("loading").html("Continue")
  } 
}

$(document).ready(function () {

  

  const registrationPopup = $("#registration-popup")
  const registrationForm = $("#registration-form")
  const registrationButton = $(".registration-button")
  const otpModal = $("#otp-modal")
  const userEmailSpan = $("#user-email")
  const closeModalBtn = $("#close-modal")
  const closeRegistrationBtn = $("#close-registration")
  const otpForm = $("#otp-form")
  const otpInputs = $('input[type="text"]', otpForm).toArray()
  const otpSubmitBtn = $("#otp-submit-btn")
  const otpErrorMsg = $("#otp-error-message")

 
  if(window.isPatriotRails){
    otpModal.removeClass("hidden");
    registrationPopup.removeClass("hidden")  
  }  

  


  registrationForm.on("submit", function (e) {
    e.preventDefault()
    verifyAuth(e, null, null, null); 
  }); 
  //  document delegation for registration button
//   $(document).on("click", ".registration-button", verifyAuth)

  // on enter key press on input fields
//   registrationForm.on("keypress", "input", function (e) {
//     if (e.key === "Enter") {
//       e.preventDefault()
//       registrationButton.trigger("click")
//     }
//   })

  // registrationButton.on('click', async function() {

  // });

  closeModalBtn.on("click", function () {
    otpModal.addClass("hidden")
  })

  closeRegistrationBtn.on("click", function () {
    registrationPopup.addClass("hidden")
  })

  otpInputs.forEach(function (input, index) {
    $(input).on("input", function (e) {
      otpErrorMsg.text("") // Clear error on new input
      if (e.target.value.length === 1 && index < otpInputs.length - 1) {
        $(otpInputs[index + 1]).focus()
      }
    })

    $(input).on("keydown", function (e) {
      if (e.key === "Backspace" && !e.target.value && index > 0) {
        $(otpInputs[index - 1]).focus()
      }
    })
  })

  otpForm.on("paste", function (e) {
    e.preventDefault()
    const pasteData = e.originalEvent.clipboardData.getData("text")
    const digits = pasteData
      .replace(/\D/g, "")
      .split("")
      .slice(0, otpInputs.length)

    digits.forEach(function (digit, index) {
      if (index < otpInputs.length) {
        $(otpInputs[index]).val(digit)
      }
    })

    if (digits.length === otpInputs.length) {
      otpSubmitBtn.focus()
    } else if (digits.length > 0) {
      $(otpInputs[digits.length]).focus()
    }
  })

  $('.resend-button').on("click", async function () {
    const email = window.c_email;
    const firstName = window.c_first_name;
    const lastName = window.c_last_name;
    verifyAuth(null, email, firstName, lastName)
  })
  

  otpForm.on("submit", async function (e) {
    e.preventDefault()
    
    const email = window.c_email;
    const otpCode = otpInputs.map((input) => $(input).val()).join("")

    if (otpCode.length !== otpInputs.length) {
      otpErrorMsg.text("Please enter a complete verification code")
      return
    }

    otpSubmitBtn.prop("disabled", true).addClass("loading").text("Verifying...")
    otpErrorMsg.text("")

    try {
      $('.verify-button').addClass('loading').html("Verifying...");
      const response = await verifyOtp(email, otpCode)
      
    //   const response= JSON.parse(responseJSON);

      if(response.location){
        $('.verify-button').removeClass('loading').html("Logging in...");
        window.location.href = response.location;
      }   
      else {
        let error= `${response.error},  (${response.attempts_remaining || 0} attempts remaining)`;
        otpErrorMsg.text(  
          error||  "Verification failed. Please try again."
        )   
        // Clear OTP inputs on failure
        otpInputs.forEach((input) => $(input).val(""))
        $(otpInputs[0]).focus()
      } 
    } catch (error) {
      console.error("OTP Verification Error:", error)
      alert(error.message || "An error occurred during verification.")
      otpErrorMsg.text(
        "An error occurred during verification. Please try again."
      )   
    } finally {
        $('.verify-button').removeClass('loading').html("Verify & Continue");
      otpSubmitBtn.prop("disabled", false).removeClass("loading").text("Verify")
    }
  })
})
